// extracted by mini-css-extract-plugin
export default {"root":"MobileViewerTxt__root--2p-Qy","body":"MobileViewerTxt__body--_e7xb","content":"MobileViewerTxt__content--Ha65e"};